import { useState, useRef, useCallback } from "react";
import AuthModal from "./AuthModal";

export const useAuthGuard = () => {
  const [authVisible, setAuthVisible] = useState(false);
  const pendingRef = useRef(null);

  const requireAuth = useCallback((fn) => {
    const uid = localStorage.getItem("userId");
    if (!uid) {
      pendingRef.current = fn;
      setAuthVisible(true);
      return false;
    }
    return true;
  }, []);

  const onAuthSuccess = useCallback(() => {
    setAuthVisible(false);
    const fn = pendingRef.current;
    pendingRef.current = null;
    fn?.();
  }, []);

  const authModal = authVisible ? (
    <AuthModal
      initialMode="login"
      onClose={() => setAuthVisible(false)}
      onSuccess={onAuthSuccess}
    />
  ) : null;

  return { requireAuth, authModal, setAuthVisible };
};
